function updateCartAttr(){
  fetch("".concat("/cart", "/update.js"), {
    body: JSON.stringify({
      attributes: {
        'brand': brand
      }
    }),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function (response) {
		console.log("update " + brand);
  });
}
document.addEventListener('DOMContentLoaded', function () {
	updateCartAttr();
});